import { loadFromLocalStorage } from "src/localStorage"

const initialState = {
  // The player's own ordering of their cities, per game: { "<gameId>": ["<col-row>", ...] }.
  // Dragged into shape in any tab, honoured by all of them (owner's P5) — a per-browser
  // preference like the pins it replaced, so it loads from localStorage and `setCityOrder`
  // writes it back there. Cities absent from the list sort after it, newest last.
  cityOrder: loadFromLocalStorage()?.cityOrder || {},
  // Which way each standing stack faces, per game: { "<gameId>": { "<userId>@<col-row>": angle } }.
  // Written off each round's show (`rememberFacings`), per browser like the city order: the board
  // carries no direction, so this is what keeps a camp turned the way its march left it.
  stackFacing: loadFromLocalStorage()?.stackFacing || {},
  // If a city is being selected when operating, we might consider other clicks as other type of actions
  // Ex: Coordinates {row: 12, col: 21}
  selectedCity: null,
  // The cell the pointer is resting on, with the pointer's screen position, for the tooltip.
  // Ex: {row: 12, col: 21, clientX: 640, clientY: 380}
  hoveredCity: null,
  // If a city is being selected when operating, we might consider other clicks as other type of actions
  // Ex: Coordinates {row: 12, col: 21}
  selectedCityForAction: null,
  // If the user is creating a movement, then, depending on the clicks that the user does, we might
  // do another thing, like considering what is being clicked as part of the original path
  creatingMovement: false,
  // Selected nodes is a variable used to hold the nodes of a movement being created or highlight cells the
  // user is interacting with. It's useful when creating movements, showing paths on the map, or selecting multiple cells.
  // Ex: Coordinates [{row: 12, col: 21}]
  selectedNodes: [],
  // "March here" pressed on the selected cell: the action bar trades its buttons for the list of
  // garrisons the march can leave from. In the store, not in the bar, because Escape backs out of
  // it (Game.js) and because it must die with the selection — as component state it outlived an
  // Escape, and the next cell clicked opened straight onto SEND TROOPS FROM.
  pickingOrigin: false,
  // What the path being drawn is for. "move" | "colonize" — the second is a march too (sent as
  // `move_troops`), whose force was picked for it: the founding party. There was a third,
  // "infiltrate", until infiltration was removed from the game on 2026-09-10; the intent survives
  // as a concept because a march with a purpose still needs its own wording on the planner.
  movementIntent: "move",
  // The force picked for the march being created (owner's Q2: units first, then route). Held in
  // the store rather than in the modal so the picker can close while the route is drawn on the
  // map — the ETA needs the slowest unit, so the troops must outlive the modal.
  // Ex: {soldier: 12}
  movementTroops: {},
  // Modal status. Control via global state which modals to open, because the conditions of opening the modals might
  // depend on different parts of the application and the status of the global data.
  // The cell a missile silo will fire FROM, set while the player picks a target. The next map
  // click is a target rather than a city selection, the same way creatingMovement reinterprets it.
  strikeOrigin: null,
  // The cell the map was last asked to centre on from outside the canvas (the city roster). `seq`
  // makes choosing the same city twice centre it twice.
  // Ex: {row: 12, col: 21, seq: 3}
  focusedCity: null,
  /* The survival spawn tour (SV12). `toured` is the arrivals already shown, keyed
     `"<tick>:<userId>"`, and it lives in the store rather than in the component for one reason:
     the game payload is re-reduced several times within a round — a chat line, a readiness flag,
     a reconnection — and each of those re-renders would otherwise fly the camera round the world
     again. `running` is whether one is on screen right now, which is what the round digest waits
     for: a modal over a map the player is being shown is a modal over nothing.
     Ex: { toured: ["0:41", "10:52"], running: false } */
  spawnTour: { toured: [], running: false },
  cityModalOpen: false,
  // Bumped by every request to open the city modal, so the watcher re-runs even when the flag was
  // already true — the flag and the modal stack can drift (a remount, a hide without onClose).
  cityModalSeq: 0,
  attackModalOpen: false,
}

export default initialState
